
import { Union } from "./fable_modules/fable-library-js.5.0.0/Types.js";
import { union_type } from "./fable_modules/fable-library-js.5.0.0/Reflection.js";
import { ofNullable } from "./fable_modules/fable-library-js.5.0.0/Option.js";
import { equals } from "./fable_modules/fable-library-js.5.0.0/Util.js";

export class Theme extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Light", "Dark", "Simple"];
    }
}

export function Theme_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Theme.Theme", [], Theme, () => [[], [], []]);
}

export function ThemeStorage_set(key, value) {
    localStorage.setItem(key, value);
}

export function ThemeStorage_get(key) {
    return ofNullable(localStorage.getItem(key));
}

export function ThemeStorage_setTheme(t) {
    const theme_1 = (t.tag === 1) ? "dark" : ((t.tag === 2) ? "simple" : "light");
    ThemeStorage_set("weatherservice.theme", theme_1);
    document.documentElement.setAttribute("data-theme", theme_1);
}

export function ThemeStorage_getTheme() {
    const matchValue = ThemeStorage_get("weatherservice.theme");
    let matchResult;
    if (matchValue != null) {
        switch (matchValue) {
            case "light": {
                matchResult = 0;
                break;
            }
            case "dark": {
                matchResult = 1;
                break;
            }
            case "simple": {
                matchResult = 2;
                break;
            }
            default:
                matchResult = 3;
        }
    }
    else {
        matchResult = 3;
    }
    switch (matchResult) {
        case 0:
            return new Theme(0, []);
        case 1:
            return new Theme(1, []);
        case 2:
            return new Theme(2, []);
        default:
            return new Theme(0, []);
    }
}

export function ThemeStorage_switchTheme() {
    ThemeStorage_setTheme(equals(ThemeStorage_getTheme(), new Theme(0, [])) ? (new Theme(1, [])) : (new Theme(0, [])));
}

export class Color extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Font", "Background", "Inactive", "Gray", "BoxFont", "BoxBackground", "BoxBackgroundGray", "MenuFont", "MenuBackground", "TrendLineWind", "TrendLineGustWind", "TrendLineAverageWind", "TrendLineWindDirection", "TrendLineTideHeight", "TrendLineTidalFlowSpeed", "TrendLineWaveHeight", "BackgroundError", "BackgroundWarning", "BackgroundSuccess", "IconError", "IconWarning", "IconSuccess", "IconWeather"];
    }
}

export function Color_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Theme.Color", [], Color, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export function ThemeModule_colorMapping(_arg, _arg_1) {
    switch (_arg_1.tag) {
        case 1:
            return "var(--color-background)";
        case 2:
            return "var(--color-inactive)";
        case 3:
            return "var(--color-gray)";
        case 4:
            return "var(--color-box-font)";
        case 5:
            return "var(--color-box-background)";
        case 6:
            return "var(--color-box-background-gray)";
        case 7:
            return "var(--color-menu-font)";
        case 8:
            return "var(--color-menu-background)";
        case 9:
            return "var(--color-trend-line-wind)";
        case 10:
            return "var(--color-trend-line-gust-wind)";
        case 11:
            return "var(--color-trend-line-average-wind)";
        case 12:
            return "var(--color-trend-line-wind-direction)";
        case 13:
            return "var(--color-trend-line-tide-height)";
        case 14:
            return "var(--color-trend-line-tidal-flow-speed)";
        case 15:
            return "var(--color-trend-line-wave-height)";
        case 16:
            return "var(--color-background-error)";
        case 17:
            return "var(--color-background-warning)";
        case 18:
            return "var(--color-background-success)";
        case 19:
            return "var(--color-icon-error)";
        case 20:
            return "var(--color-icon-warning)";
        case 21:
            return "var(--color-icon-success)";
        case 22:
            return "var(--color-icon-weather)";
        default:
            return "var(--color-font)";
    }
}

export const theme = (() => {
    const arg00$0040 = ThemeStorage_getTheme();
    return (_arg) => ThemeModule_colorMapping(arg00$0040, _arg);
})();

